// ── Importaciones tal cual ──────────────────────────────
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Nav from 'react-bootstrap/Nav';
import { Form } from 'react-bootstrap';
import Select from 'react-select'
import { Modal } from 'react-bootstrap';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { WarehouseFetchAPI } from '../../api/Warehouse';
import { GroupsFechtAPI } from '../../api/Groups';
import { InventoryFetchAPI } from '../../api/Inventory';
import ModalBranchofficeSelect from '../NavBar/ModalBranchofficeSelect';
import ModalGroupsSelect from './ModalWarehouse/ModalGroupsSelect';
import ModalselectList from './ModalWarehouse/ModalselectList';
import NavBar from '../NavBar/Navbar';
import Table from 'react-bootstrap/Table';
import SuccessAlert from '../Alerts/SuccessAlert';
import ErrorAlert from '../Alerts/ErrorAlert';


import './inandexit.css';


/* ── ICONS ── */
const IcoIn      = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>;
const IcoOut     = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>;
const IcoArrows  = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>;
const IcoDb      = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>;
const IcoStore   = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const IcoRight   = ()=><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="9 18 15 12 9 6"/></svg>;
const IcoCheck   = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoX       = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoPackage = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>;
const IcoShield  = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;

/* type config */
const TYPE_CONFIG = {
  In:       { icon: <IcoIn />,     label: 'Recepción de productos',  btnLabel: 'Guardar inventario',   sepLabel: 'Detalle del producto' },
  Exit:     { icon: <IcoOut />,    label: 'Salida de productos',     btnLabel: 'Registro de salida',   sepLabel: 'Detalle del producto' },
  Transfer: { icon: <IcoArrows />, label: 'Crear transferencias',    btnLabel: 'Transferir inventario',sepLabel: 'Productos de bodega raíz' },
};

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const InAndExit = ({ Type, selectedBranch, warehouses, setWarehouses, groups, setGroups }) => {



  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  let { business_code } = useParams();
  const [showModalExit, setShowModalExit]                         = useState(false);
  const [groupsByWarehouse, setGroupsByWarehouse]                 = useState([]);
  const [warehousesDestinationArray, setWarehousesDestinationArray] = useState([]);
  let user  = JSON.parse(localStorage.getItem('user'));
  let token = localStorage.getItem('x-access-token');
  const [userBranchoffices, setUserBranchs]     = useState([]);
  const [eventHandler, setEventHandler]         = useState(0);
  const [warehouseselected, setWarehouseSelected] = useState(0);
  const [warehouseselectedname, setWarehouseSelectedname]             = useState("Selecciona una bodega");
  const [warehouseselectednameDestination, setWarehouseSelectednameDestination] = useState("Selecciona una bodega destino");
  const [groupsSelected, setgroupsSelected]     = useState([]);
  const [groupNow, setGroupNow]                 = useState({});
  const [warehouseDestination, setWarehouseDestination] = useState(0);
  const [selectedUserOption, setSelectedUserOption]     = useState(null);
  const [reason, setReason]                             = useState('');
  const [branchSelectedDestination, setBranchSelectedDestination] = useState({ name: "Selecciona sucursal destino", code: 0, id: 0 });

  const branchList = () => userBranchoffices.map((branch, i) => (
    <option key={i} value={branch.code}>{branch.branchoffice_name}</option>
  ));

  const warehouseList = () => warehouses.map((warehouse, i) => (
    <option key={i} value={warehouse.id}>{warehouse.name}</option>
  ));

  const warehouseDestinationList = () => warehouses.map((warehouse, i) => (
    warehouseselected != warehouse.id
      ? <option key={i} value={warehouse.id}>{warehouse.name}</option>
      : null
  ));

  const listGroupsInventory = () => groupsSelected.map((group, index) => (
    <tr key={index}>
      <td>{Type == "In" ? group.name : group.group_name}</td>
      {Type != "In" && <td>{group.quantityNow}</td>}
      <td>
        <input
          id={group.group_id}
          type="number"
          defaultValue={1}
          className="form-control"
          onChange={e => handleChangeInventory(group, index, e.target.value)}
        />
      </td>
      <td>
        <button type="button" className="btn btn-outline-danger" onClick={() => deleteGroup(group)}>
          <i className="uil uil-trash-alt" />
        </button>
      </td>
    </tr>
  ));

  const getWarehouseByBrachofficeofDestination = async (branchoffice_id) => {
    try {
      const response = await WarehouseFetchAPI.getwarehousebybracnhoffice(branchoffice_id, 0, token);
      let dataWarwhousesDestinations = response.data.warehouses.filter(w => w.id !== warehouseselected && w.is_enable == 1);
      setWarehousesDestinationArray(dataWarwhousesDestinations); setEventHandler(1);
    } catch (err) { console.log(err); setWarehousesDestinationArray([]); }
  };

  const addGroups = (data) => {
    let groupData = groupNow;
    if (data != undefined) groupData = data;
    if (Type == "In") { add(); }
    else { if (groupData.quantity > 0) add(); else ErrorAlert("", "Este producto no tiene inventario", 'warning'); }

    function add() {
      let validGroup = groupsSelected.find(g => g.group_id == groupData.group_id);
      if (groupData.group_id) {
        if (validGroup == undefined) {
          groupData.quantity = "1";
          setgroupsSelected(prev => !prev.some(g => g.group_id === groupData.group_id) ? [...prev, groupData] : prev);
        }
      }
    }
  };

  const deleteGroup = (groupDelete) => {
    setgroupsSelected(groupsSelected.filter(g => g.group_id != groupDelete.group_id));
  };

  const inInventory = async () => {
    if (warehouseselected != 0) {
      let newArrayGroups = groupsSelected.map(g => ({ group_id: g.group_id, quantity: g.quantity }));
      console.log(newArrayGroups);
      let data = { warehouse_id: warehouseselected, products: newArrayGroups, user_id: user.id };
      try {
        const response = await InventoryFetchAPI.receiveInventory(data, token);
        ErrorAlert('', 'Inventario ingresado con exito', 'success'); setgroupsSelected([]);
        console.log(response);
      } catch (err) { ErrorAlert(err.response.data.error, 'Error de creacion', 'error'); }
    } else { ErrorAlert("", 'Debes seleccionar una bodega', 'warning'); }
  };

  const exitInventory = async () => {
    if (warehouseselected != 0) {
      if (reason != "") {
        let newArrayGroups = groupsSelected.map(g => ({ group_id: g.group_id, quantity: g.quantity }));
        console.log(newArrayGroups);
        let data = { warehouse_id: warehouseselected, products: newArrayGroups, user_id: user.id, reason };
        try {
          const response = await InventoryFetchAPI.sendInventory(data, token);
          ErrorAlert('', 'Salida de inventario registrado con exito', 'success');
          setgroupsSelected([]); setReason(''); setShowModalExit(false); getInventoryByWarehouse(warehouseselected);
          console.log(response);
        } catch (err) { ErrorAlert(err.response.data.error, 'Error de registro', 'error'); }
      } else { ErrorAlert("", 'Debes ingresar un concepto de salida', 'warning'); }
    } else { ErrorAlert("", 'Debes seleccionar una bodega', 'warning'); }
  };

  const transferInventory = async () => {
    if (warehouseselected != 0) {
      if (warehouseDestination != 0) {
        let newArrayGroups = groupsSelected.map(g => ({ group_id: g.group_id, quantity: g.quantity }));
        let data = { source_warehouse_id: warehouseselected, destination_warehouse_id: warehouseDestination, products: newArrayGroups, user_id: user.id };
        try {
          const response = await InventoryFetchAPI.transferInventory(data, token);
          ErrorAlert('', 'Transferencia realizada con exito', 'success'); setgroupsSelected([]); getInventoryByWarehouse(warehouseselected);
          console.log(response);
        } catch (err) { ErrorAlert(err.response.data.error, 'Error de transferencia', 'error'); }
      } else { ErrorAlert("", 'Debes seleccionar una bodega de destino', 'warning'); }
    } else { ErrorAlert("", 'Debes seleccionar una bodega raiz', 'warning'); }
  };

  const getInventoryByWarehouse = async (warehouse_id) => {
    try {
      const response = await InventoryFetchAPI.getInventoryBywarehouse(warehouse_id, token);
      console.log(response.data.inventory);
      let groupInfo = [];
      response.data.inventory.forEach(group => { group.quantityNow = group.quantity; groupInfo.push({ value: JSON.stringify(group), label: group.group_name + " Cantidad: " + group.quantity }); });
      setGroupsByWarehouse(response.data.inventory);
      console.log(response.data.inventory);
    } catch (err) {
      setGroupsByWarehouse([]); console.log("Error al consultar inventario por bodega");
      if (err.response.data.message == "Inventory not found") ErrorAlert("Esta bodega no tiene productos con inventario", 'Error de consulta', 'error');
      else ErrorAlert(err.response.data.message, 'Error de consulta', 'error');
      console.log(err);
    }
  };

  const actionselectBrachDestination = (option) => {
    getWarehouseByBrachofficeofDestination(option.id); setBranchSelectedDestination(option);
    setWarehouseDestination(0); setWarehouseSelectednameDestination("Selecciona una bodega destino");
  };

  const actionselectWarehouse = async (option) => {
    setWarehouseSelectedname(option.name); handleChangeWarehouseSelected(option);
    let dataWarwhousesDestinations = warehouses.filter(w => w.id !== option.id);
    setWarehousesDestinationArray(dataWarwhousesDestinations); setgroupsSelected([]);
  };

  const actiondestinationwarehouse = (option) => {
    setWarehouseDestination(option.id); setWarehouseSelectednameDestination(option.name);
  };

  const handleChangeWarehouseSelected = (data) => {
    setGroupsByWarehouse([]); setGroupNow({}); setEventHandler(1); setWarehouseSelected(data.id);
    console.log("Seleccion de bodega ");
    if (Type == "Exit" || Type == "Transfer") getInventoryByWarehouse(data.id);
  };

  const handleChangeInventory = (group, index, quantity) => {
    let quantityType = 1;
    if (quantity != "") quantityType = quantity;
    if (Type == "In") { console.log("Entre"); addGroupNow(); }
    else {
      if (parseInt(group.quantityNow) >= parseInt(quantity)) addGroupNow();
      else { let valueInput = document.getElementById(group.group_id); if (valueInput.value != "") ErrorAlert("", "La cantidad ingresada no puede ser mayor a la cantidad actual", 'warning'); }
    }
    function addGroupNow() {
      let newGroups = groupsSelected.map((g, i) => i === index ? { ...g, quantity: quantityType } : g);
      setgroupsSelected(newGroups);
    }
  };

  const handleSaveTableSelect = (option) => { setGroupNow(JSON.parse(option.value)); };

  const handleActionButton = () => {
    groupsSelected.forEach(group => { if (group.quantity == "" || group.quantity == undefined || group.quantity == null) group.quantity = 1; });
    if (Type == "Exit") setShowModalExit(true);
    else if (Type == "Transfer") transferInventory();
    else inInventory();
  };

  useEffect(() => {
    const branchesWithFields = user.branchoffices.map(branch => ({ ...branch, name: branch.branchoffice_name, id: branch.branchoffice_id }));
    setUserBranchs(branchesWithFields); setBranchSelectedDestination(selectedBranch);
    setWarehouseSelected(0); setWarehouseSelectedname("Selecciona una bodega"); setgroupsSelected([]);
  }, [selectedBranch]);

  useEffect(() => { setEventHandler(0); }, [eventHandler]);
  useEffect(() => {}, [groupsSelected]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  const cfg = TYPE_CONFIG[Type] || TYPE_CONFIG.In;

  return (
    <>
      <div style={{ padding: '0 .25rem' }}>

        {/* ── banner ── */}
        <div className="iae-banner">
          <div className="iae-banner-title">{cfg.icon} {cfg.label}</div>
          <span className="iae-required-hint"><b>*</b> Campos obligatorios</span>
        </div>

        {/* ── CARD PRINCIPAL ── */}
        <div className="iae-card">

          {/* head dark */}
          <div className="iae-card-head">
            <div className="iae-card-head-ico">{cfg.icon}</div>
            <span className="iae-card-head-title">Detalle de almacenamiento</span>
          </div>

          <div className="iae-card-body">

            {/* ── SELECTORES DE BODEGA ── */}
            <div className="iae-selectors">

              {/* Bodega raíz / origen */}
              <div className="iae-field">
                <label className="iae-label">
                  <IcoDb />
                  Bodega {Type === "Transfer" ? "raíz" : ""} <span className="iae-required">*</span>
                </label>
                {/* ModalselectList — props exactos */}
                <ModalselectList
                  action={actionselectWarehouse}
                  dataArray={warehouses}
                  title="Selecciona una bodega"
                  dataselected={warehouseselectedname}
                  section="Bodegas"
                />
              </div>

              {/* Sucursal destino (solo Transfer) */}
              {Type === "Transfer" && (
                <>
                  <div className="iae-field">
                    <label className="iae-label">
                      <IcoStore /> Sucursal destino <span className="iae-required">*</span>
                    </label>
                    <ModalselectList
                      action={actionselectBrachDestination}
                      dataArray={userBranchoffices}
                      title="Selecciona una sucursal destino"
                      dataselected={branchSelectedDestination.name}
                      section="Sucursal destino"
                    />
                  </div>
                  <div className="iae-field">
                    <label className="iae-label">
                      <IcoDb /> Bodega destino <span className="iae-required">*</span>
                    </label>
                    <ModalselectList
                      action={actiondestinationwarehouse}
                      dataArray={warehousesDestinationArray}
                      title="Selecciona una bodega destino"
                      dataselected={warehouseselectednameDestination}
                      section="Bodegas destino"
                    />
                  </div>
                </>
              )}
            </div>

            {/* ── SECCIÓN PRODUCTO ── */}
            <div className="iae-sep">
              <div className="iae-sep-line" />
              <span className="iae-sep-label"><IcoPackage /> {cfg.sepLabel}</span>
              <div className="iae-sep-line" />
            </div>

            <div className="iae-field" style={{ maxWidth: 320 }}>
              <label className="iae-label">
                <IcoPackage /> Producto <span className="iae-required">*</span>
              </label>
              {/* ModalGroupsSelect — props exactos */}
              {Type === "In" ? (
                <ModalGroupsSelect productsBranchoffice={groups} addGroups={addGroups} />
              ) : (
                <>
                  <ModalGroupsSelect productsBranchoffice={groupsByWarehouse} addGroups={addGroups} />
                  <span className="iae-product-hint">
                    {Type === "Transfer"
                      ? "Selecciona la bodega raíz para ver los productos disponibles"
                      : "Selecciona la bodega para ver los productos disponibles"}
                  </span>
                </>
              )}
            </div>

            {/* ── TABLA DE PRODUCTOS ── */}
            {groupsSelected.length > 0 && (
              <>
                <div className="iae-sep">
                  <div className="iae-sep-line" />
                  <span className="iae-sep-label"><IcoPackage /> Productos agregados ({groupsSelected.length})</span>
                  <div className="iae-sep-line" />
                </div>

                {/* Table — importación original intacta */}
                <Table responsive>
                  <thead className="table-dark">
                    <tr>
                      <th>Producto</th>
                      {Type !== "In" && <th>Cantidad actual</th>}
                      <th>Cantidad ingresada</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* listGroupsInventory() — lógica original intacta */}
                    {listGroupsInventory()}
                  </tbody>
                </Table>

                <div className="iae-save-row">
                  <button type="button" className="iae-btn-save" onClick={() => handleActionButton()}>
                    <IcoCheck /> {cfg.btnLabel}
                  </button>
                </div>
              </>
            )}

          </div>{/* end card-body */}
        </div>{/* end iae-card */}

        {/* originales ocultos — preserva imports ── */}
        <div style={{ display:'none' }}>
          <form className="row bg-white p-0 p-lg-2 mt-1 border-sp border">
            <div className="col-4 col-sm-4 col-md-4 col-lg-4 mt-1">
              <div className="form-group">
                <label htmlFor="input_from">Bodega {Type == "Transfer" ? <>raiz</> : <></>}<b className="text-danger"> * </b></label>
              </div>
            </div>
            {Type == "Transfer" && (
              <>
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 mt-1">
                  <div className="form-group"><label htmlFor="input_from"><i className="uil uil-arrow-right" />Sucursal destino<b className="text-danger"> * </b></label></div>
                </div>
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 mt-1">
                  <div className="form-group"><label htmlFor="input_from">Bodega destino<b className="text-danger"> * </b></label></div>
                </div>
              </>
            )}
            <select>{branchList()}</select>
            <select>{warehouseList()}</select>
            <select>{warehouseDestinationList()}</select>
          </form>
          <Row><Col><Nav><Tabs><Tab eventKey="x" title="x" /></Tabs></Nav></Col></Row>
        </div>

      </div>

      {/* ══ MODAL SALIDA ═══════════════════════════════ */}
      <Modal
        show={showModalExit}
        onHide={() => setShowModalExit(false)}
        size="large"
        centered
        dialogClassName="iae-exit-dialog"
      >
        <Modal.Header>
          <h3><i className="uil uil-file-shield-alt" />Concepto de la salida</h3>
        </Modal.Header>
        <Modal.Body>

          {/* visual head */}
          <div className="iae-modal-head">
            <div className="iae-modal-head-ico"><IcoShield /></div>
            <div className="iae-modal-head-title">Concepto de la salida</div>
            <button className="iae-modal-close" type="button" onClick={() => setShowModalExit(false)}><IcoX /></button>
          </div>

          <div className="iae-modal-body">
            <span className="iae-modal-label">Describa el motivo de la salida de inventario</span>
            {/* Form original — lógica intacta */}
            <Form>
              <Form.Group className="m-3" controlId="exampleForm.ControlTextarea1">
                <Form.Label>Describa el concepto de la salida:</Form.Label>
                <Form.Control as="textarea" rows={3} onChange={e => setReason(e.target.value)} />
              </Form.Group>
            </Form>
          </div>

          <div className="iae-modal-footer">
            <button type="button" className="iae-btn-cancel btn btn-danger" onClick={() => setShowModalExit(false)}>Cerrar</button>
            <button type="button" className="iae-btn-confirm btn btn-primary" onClick={() => exitInventory()}>
              <IcoCheck /> Guardar
            </button>
          </div>

        </Modal.Body>
      </Modal>

      {/* imports no-JSX preservados */}
      {void [SuccessAlert, ErrorAlert, NavBar, BranchOfficeFetchAPI, GroupsFechtAPI, Select, ModalBranchofficeSelect, handleSaveTableSelect]}
    </>
  );
};

export default InAndExit;